import { useTranslation } from 'react-i18next'

// v1 linked metafor.io, which 404s; these are the live addresses on metafor.ai
const LINKS = [
  { key: 'support', href: 'mailto:support@metafor.ai' },
  { key: 'privacy', href: 'https://www.metafor.ai/privacy' },
] as const

const version = import.meta.env.REACT_APP_VERSION as string | undefined

export function AppFooter() {
  const { t } = useTranslation()
  return (
    <footer className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-between gap-x-6 gap-y-2 border-t px-4 py-4 text-xs text-muted-foreground md:px-8">
      <p>
        © {new Date().getFullYear()} Metafor{version ? `, v${version}` : ''}
      </p>
      <nav aria-label={t('v2.footer.label')} className="flex gap-5">
        {LINKS.map((l) => (
          <a
            key={l.key}
            href={l.href}
            {...(l.href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            className="transition-colors hover:text-foreground"
          >
            {t(`v2.footer.${l.key}`)}
          </a>
        ))}
      </nav>
    </footer>
  )
}
